import { oneTrustScriptProdUrl } from "./constants";

export const injectOneTrust = () => {
  const scriptId = "one-trust-script";
  const oneTrustScript = document.getElementById(scriptId);
  if (oneTrustScript) return;
  const scriptUrl = oneTrustScriptProdUrl;
  console.log("Injecting one trust script", scriptUrl);
  const script = createScript(scriptId, scriptUrl);

  if (document.head.prepend) {
    document.head.prepend(script);
  } else {
    document.head.appendChild(script);
  }
};

export const createScript = (scriptId: string, src: string) => {
  const script = document.createElement("script");

  script.setAttribute("id", scriptId);
  script.setAttribute("charset", "UTF-8");
  script.setAttribute("src", src);

  return script;
};
